import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { scrollToSection } from "../utils/scrollToSection";

const links = [
  { href: "#dashboard", label: "Dashboard" },
  { href: "#services", label: "Services" },
  { href: "#projects", label: "Projects" },
  { href: "#downloads", label: "Downloads" },
  { href: "#messages", label: "Messages" },
];

export default function Sidebar({ sidebarOpen, setSidebarOpen }) {
  const location = useLocation();
  const [activeHash, setActiveHash] = useState("#dashboard");

  useEffect(() => {
    setActiveHash(location.hash || "#dashboard");
  }, [location.hash]);

  const handleClick = (e, href) => {
    e.preventDefault();
    setActiveHash(href);
    scrollToSection(href);
    window.history.replaceState(null, "", href);

    // 🔥 اقفل السايدبار في الموبايل بعد الاختيار
    setSidebarOpen(false);
  };

  return (
    <>
      {/* 🔥 Overlay للموبايل */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 bg-black/60 z-40 lg:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      <aside
        className={`
          fixed lg:static
          top-0 left-0
          h-full w-[280px]
          bg-[#08080A]
          border-r border-white/10
          text-zinc-300 backdrop-blur-xl
          p-6
          z-50
          transform transition-transform duration-300

          ${sidebarOpen ? "translate-x-0" : "-translate-x-full"}
          lg:translate-x-0
        `}
      >
        {/* Top Glow */}
        <div className="absolute inset-x-0 top-0 h-32 bg-[#F28C18]/10 blur-3xl" />

        {/* Header */}
        <div className="relative mb-10">
          <p className="text-xs uppercase tracking-[0.35em] text-zinc-500">
            Admin Panel
          </p>

          <h2 className="mt-2 text-2xl font-black text-white">
            Integrated Admin
          </h2>

          <p className="mt-2 text-sm text-zinc-500 leading-relaxed">
            Control center for your dashboard with smooth navigation.
          </p>
        </div>

        {/* Close button (mobile only) */}
        <button
          onClick={() => setSidebarOpen(false)}
          className="lg:hidden absolute top-4 right-4 text-white text-xl"
        >
          ✕
        </button>

        {/* Nav */}
        <nav className="relative space-y-2">
          {links.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={(e) => handleClick(e, link.href)}
              className={`group relative block rounded-2xl px-4 py-3 text-sm font-black uppercase tracking-[0.25em] transition-all duration-300 ${
                activeHash === link.href
                  ? "bg-[#F28C18] text-black shadow-lg shadow-[#F28C18]/30"
                  : "text-zinc-400 hover:bg-white/10 hover:text-white"
              }`}
            >
              <span className="relative z-10">{link.label}</span>

              {/* hover glow */}
              <span className="absolute inset-0 rounded-2xl opacity-0 transition group-hover:opacity-100 bg-[#F28C18]/10" />
            </a>
          ))}
        </nav>
      </aside>
    </>
  );
}